import API_ENDPOINTS from "@/common/api/apiEndpoints";
import httpClient from "@/common/api/httpClient";
import httpMethods from "@/common/api/httpMethods";

export interface GuideMePreviewStartResult {
  versionId: string;
  projectId: number;
  expiresAt: string;
}

export interface GuideMePreviewStatus {
  active: boolean;
  versionId?: string;
  expiresAt?: string;
}

/**
 * Silently switches the current user's active project/version to this
 * organization's Sample Project for the duration of a Guide Me tour. The
 * switch is server-side and real (not just client-side state) but never
 * persisted as the org's "last project" — see guideMePreviewSessionService.
 */
export const startGuideMePreview = (organizationId: number) =>
  httpClient<GuideMePreviewStartResult>(httpMethods.POST, API_ENDPOINTS.GUIDE_ME.previewStart, {
    organizationId,
  }).then((res) => res.data);

/**
 * Ends the active preview session (if any), restoring the user's original
 * active project. Safe to call unconditionally on every tour-exit path.
 */
export const endGuideMePreview = () =>
  httpClient<{ ok: boolean }>(httpMethods.POST, API_ENDPOINTS.GUIDE_ME.previewEnd).then(
    (res) => res.data,
  );

/** Lets the frontend detect a still-active preview session after a reload. */
export const getGuideMePreviewStatus = () =>
  httpClient<GuideMePreviewStatus>(httpMethods.GET, API_ENDPOINTS.GUIDE_ME.previewStatus).then(
    (res) => res.data,
  );
